import { render, staticRenderFns } from "./contentTitle.vue?vue&type=template&id=277c45fe&scoped=true"
import script from "./contentTitle.vue?vue&type=script&lang=js"
export * from "./contentTitle.vue?vue&type=script&lang=js"
import style0 from "./contentTitle.vue?vue&type=style&index=0&id=277c45fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c45fe",
  null
  
)

export default component.exports